import ShortLinkAPI from '@/apis/business/common/short-link-api.js'

export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    /**
     * @description Convert shortLink
     * @author NTQuy
     * @param {*} context
     * @param {*} defaultAction
     * @returns
     */
    convertLink (context, param) {
      return new Promise((resolve, reject) => {
        ShortLinkAPI.postAsync('/convert', param).then(res => {
          resolve(res.Data)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
